import { useMutation, useQueryClient } from "@tanstack/react-query";

export interface CreateReviewData {
  customer_name: string;
  rating: number;
  review_text: string;
  type: string;
  product_id?: string;
  lat?: string | number | null;
  lan?: string | number | null;
}

export interface CreateReviewResponse {
  status: string;
  message: string;
  data: {
    id: string;
    customer_name: string;
    rating: number;
    review_text: string;
    review_image_url: string | null;
    type: string;
    product: any;
    approved_at: string;
    created_at: string;
  };
}

export const useCreateReview = () => {
  const queryClient = useQueryClient();

  return useMutation<CreateReviewResponse, Error, CreateReviewData>({
    mutationFn: async (data) => {
      const response = await fetch(
        `https://back.sewargourmet.com/api/v1/reviews`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        },
      );

      if (!response.ok) {
        throw new Error("Failed to create review");
      }

      return response.json();
    },
    onSuccess: () => {
      // Invalidate reviews query to refetch data
      queryClient.invalidateQueries({ queryKey: ["reviews"] });
    },
  });
};
